import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";
import axios from "../../../../utils/axiosInceptor";

const requestBankDetails = async (userId: string) => {
  const url = `${apiV1Endpoint}/tenant/${userId}/request-bank-details`;
  const response = await axios.post<ApiResponse>(url);
  return response.data.result;
};

type UseRequestBankDetailsOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useRequestBankDetails = (options: UseRequestBankDetailsOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: requestBankDetails,
    onSuccess,
    onError,
  });

  return {
    requestBankDetails: mutateAsync,
    isPending,
  };
};
